import { render } from "./Electricity.vue?vue&type=template&id=78f467e5&bindings={\"dev\":\"data\",\"isRecording\":\"data\",\"sounds\":\"data\",\"sound\":\"data\",\"soundBack\":\"data\",\"events\":\"data\",\"eventsBack\":\"data\",\"startTime\":\"data\",\"isAnimating\":\"data\",\"createAndAnimateCircle\":\"options\",\"startRecording\":\"options\",\"stopRecording\":\"options\",\"recordEvent\":\"options\",\"playback\":\"options\",\"playbackBack\":\"options\",\"saveRecording\":\"options\"}"
import script from "./Electricity.vue?vue&type=script&lang=js"
export * from "./Electricity.vue?vue&type=script&lang=js"

import "./Electricity.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script